import api from './api';

export const userService = {
  auth,
  logout,
};
function auth(userDetails) {
  return (
    api
      .post(`login?account=users`, userDetails)
      // .then(handleResponse)
      .then(user => {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        localStorage.setItem('user', JSON.stringify(user));

        return user;
      })
  );
}

// function handleResponse(response) {
//   return response.text().then((text) => {
//     const data = text && JSON.parse(text);
//     if (!response.ok) {
//       if (response.status === 401) {
//         // auto logout if 401 response returned from api
//         logout();
//         window.location.reload(true);
//       }

//       const error = (data && data.message) || response.statusText;
//       return Promise.reject(error);
//     }

//     return data;
//   });
// }

function logout() {
  // remove user from local storage to log user out
  // localStorage.removeItem("user");
  localStorage.clear();
}

